module.exports = __webpack_public_path__ + "static/media/Photo_CV.96faab97.jpg";